import { ValueRepresentation } from '../../core/types/scales.js';
import { UNSUPPORTED_PROP_VALIDATION_MESSAGE } from '../messages/prop-validation-overwrite.js';
import { Inconsistency } from '../types/inconsistency.js';
import { ValidationResult } from '../types/timeseries-validations.js';
import { TimeseriesPerVariant } from '../types/timeseries.js';

const RELATIVE_VALUE_REPRESENTATION = 'relative';
const FALLBACK_VALUE_REPRESENTATION = 'absolute';

export const getValueRepresentationValidation = (
  valueRepresentation: ValueRepresentation,
  _: TimeseriesPerVariant,
  inconsistencies: unknown,
): ValidationResult<ValueRepresentation> => {
  const hasMisalignedDatapoints = (
    inconsistencies as Record<Inconsistency, boolean>
  ).misalignedDatapoints;

  const validationResult: ValidationResult<ValueRepresentation> = {
    field: 'valueRepresentation',
    sanitizedValue: valueRepresentation,
  };

  if (
    hasMisalignedDatapoints &&
    valueRepresentation === RELATIVE_VALUE_REPRESENTATION
  ) {
    validationResult.message = {
      severityLevel: 'warning',
      descriptor:
        UNSUPPORTED_PROP_VALIDATION_MESSAGE.relativeValRepMisalignedDatapoints,
    };
    validationResult.sanitizedValue = FALLBACK_VALUE_REPRESENTATION;
  }

  return validationResult;
};
